import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { analyticsContextSchema } from "../analytics";
import { userSchema } from "../user";

export const completeProfileSchema = userSchema
  .pick({ name: true, username: true, locale: true })
  .extend({
    // The one required box: the Privacy Policy, the Terms of Service (which cover AI processing of
    // the user's resume and conversation transcripts and occasional marketing emails, with an
    // unsubscribe link in each).
    acceptTerms: z.boolean().refine((val) => val === true, {
      message: "You must agree to the Privacy Policy, the Terms of Service and AI processing",
    }),
    // Set when the visitor came through First Round (firstround.com.au, its demo or a
    // First Round-branded sign-up). Every new user is a First Round lead; this picks the source.
    firstRound: z.boolean().optional(),
    // First-touch attribution for the lead (UTMs and landing page), if the browser has it.
    utmSource: z.string().max(200).optional(),
    utmMedium: z.string().max(200).optional(),
    utmCampaign: z.string().max(200).optional(),
    landingPage: z.string().max(200).optional(),
    analyticsContext: analyticsContextSchema.optional(),
  });

export class CompleteProfileDto extends createZodDto(completeProfileSchema) {}
